import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { UTILITIES_PATHS } from './UtilitiesConstants'

const Color = EgretLoadable({
  loader: async () => await import('./Color')
})

const utilitiesRoutes: RouteConfig[] = [
  {
    path: UTILITIES_PATHS.COLOR,
    component: Color
  }
]

export default utilitiesRoutes
